import React from 'react';
import { apiClient } from './ApiClient';
import { CrudService } from './CrudService';

export const ControlService = ({ getToken }: any) => {

  const getControls = async (inputData: any) => {
    let token = await getToken();
    let apiOptions: any = {
      url: 'controls/query',
      method: 'post',
      data: inputData,
    };
    let result = await apiClient.doAction(apiOptions, token);
    return result;
  }

  const getMyControls = async () => {
    let apiOptions: any = {
      url: 'my/controls',
      method: 'get'
    };
    let result = await apiClient.doAction(apiOptions);
    return result;
  }

  const getRoleControls = async (inputData: any) => {
    let apiOptions: any = {
      url: 'roles/GetRoleControlMapByRoleCode',
      method: 'post',
      data: inputData
    };
    let result = await apiClient.doAction(apiOptions);
    return result;
  }

  const saveControls = async (inputData: any) => {
    let apiOptions: any = {
      url: 'roles/ManageRoleControlMaps',
      method: 'post',
      data: inputData,
    };
    let result = await apiClient.doAction(apiOptions);
    return result;
  }

  return { getControls, getMyControls, getRoleControls, saveControls };
}

const crudService = CrudService('controls');
export const getControls = async (inputData: any) => { return await crudService.getItems(inputData); }
export const getControlById = async (inputData: any) => { return await crudService.getItemById(inputData); }
export const addControl = async (inputData: any) => { return await crudService.addItem(inputData); }
export const updateControl = async (inputData: any) => { return await crudService.updateItem(inputData); }
export const deleteControl = async (inputData: any) => { return await crudService.deleteItem(inputData); }
export const getLookups = async (inputData: any) => { return await crudService.getLookups(inputData); }
